module.exports = __webpack_public_path__ + "src/assets/img/anon.459a0b2a.svg";